<template>
	<div class="pdp-v4">
		<div class="pdp-header">
			<span class="pdpTitle">{{ content.pdpTitle }}</span>
			<button :aria-label="content.pdpClose" class="close-btn" tabindex="0" @click="closePdp" @keydown.esc="closePdp">
				<img alt="Close" src="/images/icon-close-white.svg" />
			</button>
		</div>
		<div ref="toastContent" class="pdp-content">
			<div class="content-container">
				<div class="pdpContainer">

					<div class="top-section">
						<div><img :src="product.productImage" class="productImage" /></div>
	

						<div class="details-container">
							<div class="price" tabindex="0">
								<h2>
									<span v-if="pricePrefix"> {{ pricePrefix }} </span>
									<span v-if="priceQty">{{ priceQty }} /</span>
									<span> {{ salePrice }}</span>
									<span v-if="promoUnit"> {{ promoUnit }} </span>
									<span v-if="taxSuffix" class="tax">{{taxSuffix}}</span>
									<p v-if="alternatePrice" class="alternatePrice">{{ alternatePrice }}</p>

								</h2>
							</div>

							<div v-if="product.savingsFr" class="savings">
								<span>
									{{ product.savingsPrefixFr }}
									{{ product.savingsFr }}
									{{ product.savingsSuffixFr }}</span>
							</div>
							<div v-if="regularPrice" class="regularPrice">
								<span class="label">{{content.pdpRegularPrice}} :</span>
								<span>{{regularPrice}}</span>
							</div>

							<h2 class="productName">
								<template v-if="isUniprix">
									<span v-if="product.productFr !== null" tabindex="0" ref="pdpWindow">{{ product.productFr }}</span>
									<span v-else-if="product.productEn !== null"> {{ product.productEn }} </span>
								</template>
								<template v-else-if="language === 'en'">
									<span v-if="product.productEn !== null" tabindex="0" ref="pdpWindow">{{ product.productEn }}</span>
									<span v-else-if="product.productFr !== null"> {{ product.productFr }} </span>
								</template>
								<template v-else>
									<span v-if="product.productFr !== null" tabindex="0" ref="pdpWindow">{{ product.productFr }}</span>
									<span v-else-if="product.productEn !== null"> {{ product.productEn }} </span>
								</template>
							</h2>

							<div v-if="description" class="detail">
								<p class="detail-content" v-html="htmlDescription" />
							</div>

							<div class="validity">
								<span>{{ content.pdpValidFrom }} </span>
								<span class="date" v-html="flyerDate(product.validFrom, product.validTo)"></span>
							</div>

							<div class="addtoList-container">
								<button v-if="checkProductInSL(product)" class="pdpAddToList removeFromList" tabindex="0"
									@click="handleRemoveFromList(product)">
									<span> {{ content.pdpRemoveFromList }} </span>
								</button>

								<button v-else-if="listEnabled" class="pdpAddToList" tabindex="0" @click="handleAddToList(product)">
									<span> {{ content.pdpAddToList }} </span>
								</button>
							</div>
						</div>
						<p class="disclaimer-content">{{ content.disclaimer }}</p>
						<figure v-if="product.mainCategoryEn === 'OVER THE COUNTER DRUGS'" class="otp-disclaimer">
							<img src="/images/uniprix-otp-disclaimer_desktop.jpg" class="otp-desktop" alt="Avis concernant les pharmaciens-propriétaires affiliés à Uniprix"
								aria-describedby="notice-text">
							<img src="/images/uniprix-otp-disclaimer_mobile.jpg" class="otp-mobile" alt="Avis concernant les pharmaciens-propriétaires affiliés à Uniprix"
								aria-describedby="notice-text">

							<figcaption id="notice-text" class="sr-only">
								<p>
									Les pharmaciens-propriétaires affiliés à Uniprix sont les seuls
									responsables de l'exercice de la pharmacie.
								</p>

								<p>
									Pour consulter la liste des pharmaciens-propriétaires, visitez uniprix.com.
								</p>

								<p><strong>MESSAGE IMPORTANT</strong></p>

								<p>
									Tout médicament ou produit de santé naturel peut causer des effets indésirables sérieux ou des
									interactions avec d'autres médicaments. Lire attentivement les instructions, mises en garde et
									dépliants fournis par le fabricant et consulter votre pharmacien lors de l'achat de tels médicaments
									ou produits de santé naturels. Toujours tenir les médicaments et produits de santé naturels hors de la
									portée des enfants. Les pharmaciens propriétaires affiliés à Jean Coutu sont les seuls responsables de
									la vente de ces médicaments.
								</p>
							</figcaption>
						</figure>
					</div>

					<div v-if="similarItems.length > 0" class="similar-items">
						<div class="similar-items-header">
							<span v-show="hasCarousel" :class="['carousel-arrow', 'carousel-arrow-prev', { disabled: carouselIndex === 0 }]" aria-label="Previous" @click="prevSlide"></span>
							<h3 class="similar-items-title">{{ content.pdpSimilarItems }}</h3>
							<span v-show="hasCarousel" :class="['carousel-arrow', 'carousel-arrow-next', { disabled: carouselIndex >= totalPages - 1 }]" aria-label="Next" @click="nextSlide"></span>
						</div>
						<div class="similar-items-carousel">
							<div class="similar-items-list" :class="{ 'single-item': similarItems.length === 1 }">
								<div class="similar-item" v-for="item in visibleSimilarItems" :key="item.sku"
									@click.stop="handleSimilarItemClick(item)">
									<div class="similar-item-image-container">
										<img :src="item.image" :alt="item.name" class="similar-item-image" />
									</div>
									<div class="similar-item-details">
										<div class="similar-item-price">
											<span v-if="item.priceQty">{{ item.priceQty }} /</span>
											<span>{{ item.salePrice }}</span>
											<span v-if="item.promoUnit"> {{ item.promoUnit }} </span>
										</div>
										<div v-if="item.savings" class="similar-item-savings">
												{{ product.savingsPrefixFr }}
												{{ product.savingsFr }}
												{{ product.savingsSuffixFr }}
										</div>
										
										<div class="similar-item-validity">
											<span v-if="language === 'fr'">En vigueur du {{ item.validity }}</span>
											<span v-else>{{ content.pdpValidFrom }} <span v-html="flyerDate(item.validFrom, item.validTo)"></span></span>
										</div>
									</div>
									<button class="similar-item-add-btn" :class="{ 'in-list': item.isInList }"
										@click.stop="handleSimilarItemAddToList(item)">
										{{ item.isInList ? content.pdpRemoveFromList : content.pdpAddToList }}
									</button>
								</div>
							</div>
						</div>
					</div>


				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import featureMixin from "@/mixins/featureMixin";
import AppConfig from "@/classes/AppConfig";
import PdpProductMixin from "@/features/pdp/PdpProductMixin";
import { PDP_EVENT_SHOW } from "@/features/pdp/PDP_Constants";
import Lytics from "@/classes/Lytics";

export default {
	directives: {
		ClickOutside,
	},
	mixins: [featureMixin, PdpProductMixin],

	data() {
		return {
			toastContent: null,
			ready: true,
			carouselIndex: 0
		};
	},
	mounted() {
    /*this.$refs.pdpWindow.focus()*/
	},
	computed: {
		...mapGetters(["content", "language"]),
		...mapGetters("screen", ["flyerOrientation", "displayMode"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		...mapState("shoppingList", ["shoppingList"]),
		...mapGetters("pdp", { pdpEnabled: "enabled" }),
		...mapGetters('shoppingList', { listEnabled: 'enabled' }),

		columnView() {
			return this.flyerOrientation === "vertical";
		},

		enabled() {
			return this.pdpEnabled && this.config.mode === 'internal';
		},

		isRichelieu() {
			if (AppConfig.AppConf?.title.toLowerCase().includes("richelieu".toLowerCase())) {
				return true
			} else return false
		},
		isAdonis() {
			if (AppConfig.AppConf?.title.toLowerCase().includes("adonis".toLowerCase())) {
				return true
			} else return false
		},
		isUniprix()
		{
			if (AppConfig.AppConf?.title.toLowerCase().includes("uniprix".toLowerCase())) {
				return true
			} else return false
		},
		similarItems() {
			if (!this.product?.blockData?.products || !Array.isArray(this.product.blockData.products)) {
				return [];
			}

			const currentSku = this.sku;
			const allProducts = this.product.blockData.products;

			
			// always exclude InblockSKU/AnimateSKU items from Related Products.
			// If a matching Product entry exists for that SKU it will be shown instead,
			// preventing both duplication and blank images.

			const filtered = allProducts
				.filter(item => {
					// Filter out items with no SKU or matching the current (open) product
					const itemSku = this.extractItemProp(item, 'sku');
					if (!itemSku || itemSku === currentSku) return false;

					// Exclude InblockSKU / AnimateSKU entries — these are video/animation
					// triggers, not product cards. The corresponding Product entry (same SKU)
					// carries the image and pricing data and will be shown instead.
					const at = (item.actionType || '').toLowerCase();
					if (at.includes('inblock') || at.includes('animate')) return false;

					return true;
				})
									

				.map(item => {
					// Get all necessary properties
					const productImage = this.extractItemProp(item, 'productImage');
					const productName = (this.extractItemProp(item, 'productFr') || this.extractItemProp(item, 'productEn'));
					const itemSku = this.extractItemProp(item, 'sku');

					// Get price information
					const priceQty = this.extractItemProp(item, 'priceQuantity');
					const salePrice = this.getSimilarItemPrice(item);
					const promoUnit = this.extractItemProp(item, 'promoUnitFr') || this.extractItemProp(item, 'promoUnitEn');

					// Get savings
					const savings = this.getSimilarItemSavings(item);

					// Get validity
					const validity = this.getSimilarItemValidity(item);

					// Check if in shopping list
					const isInList = this.checkProductInSL(item);

					return {
						...item, // Keep the full product object
						sku: itemSku,
						image: productImage,
						name: productName,
						priceQty: priceQty ? `${priceQty}` : '',
						salePrice: salePrice,
						promoUnit: promoUnit || '',
						savings: savings,
						validity: validity,
						isInList: isInList
					};
				});

			return filtered;
		},

		totalPages() {
			return Math.ceil(this.similarItems.length / 2);
		},

		isMobile() {
			return this.displayMode === 'mobile';
		},

		visibleSimilarItems() {
			if (this.isMobile) return this.similarItems;
			const start = this.carouselIndex * 2;
			return this.similarItems.slice(start, start + 2);
		},

		hasCarousel() {
			return this.similarItems.length > 2;
		},

	},

	methods: {
		...mapActions(["setPdpDisplay", "setCurrentProduct"]),
		...mapActions("shoppingList", ["setAddToList", "setRemoveFromList"]),
		...mapActions("pdp", ["close", "open"]),
		...mapActions("events", ["triggerEvent"]),

		/**
		 * Extracts a property from an item using the same logic as extractProductProp
		 * @param {Object} item - The product item
		 * @param {string} prop - The property name to extract
		 * @returns {string} - The extracted property value
		 */
		extractItemProp(item, prop) {
			const lang = this.config?.props?.[prop]?.lang || this.language;
			const capitalizedLang = lang.charAt(0).toUpperCase() + lang.slice(1);
			const strict = item?.[`${prop}${capitalizedLang}`] || item?.[prop];
			const loose = item?.[`${prop}En`] || item?.[`${prop}Fr`];
			return strict || loose || '';
		},

		closePdp() {
			this.close();
		},
		handleAddToList(product) {
			const additionalItemFlag = false;
			this.setAddToList({ product, additionalItemFlag });
		},

		handleRemoveFromList(product) {
			this.setRemoveFromList(product);
		},

		checkProductInSL(product) {
			let item = this.shoppingList.filter(function (e) {
				return e.sku === product.sku;
			});
			return item.length > 0;
		},
		showPriceFr(price) {
			if (!price) return;

			return (
				parseFloat(price)
					.toFixed(2)
					.replace(".", ",") + " $"
			);

		},
		showPriceEn(price) {
			if (!price) return;
			else if (price.includes("$")) {
				let priceWith$ = price.replace("$", "");
				if (priceWith$.includes(",")) {
					let enPrice = priceWith$.replaceAll(",", ".");
					return "$" + enPrice;
				}
				return "$" + priceWith$;
			}
			return "$" + price.replace(",", ".");
		},
		flyerDate(validFrom, validTo) {
			const start = validFrom ? moment.utc(validFrom) : moment.utc(this.currentFlyer.startDate);
			const endDate = validFrom ? moment.utc(validTo) : moment.utc(this.currentFlyer.endDate);
			if (this.language === "en") {
				return `${start.locale('en').format("MMM D, YYYY")} to ${endDate.locale('en').format("MMM D, YYYY")}`;
			} else {
				return `${start.format("D MMM YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} - ${endDate.format("D MMM YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')}`;
			}
		},

		getSimilarItemPrice(item) {
			let price = this.extractItemProp(item, 'salePrice');
			if (!price || price === '$NaN' || price === 'NaN$') {
				return '';
			}
			if(!isNaN(price)) {
				price = parseFloat(price).toFixed(2);
				price = price.replace('.', ',');
			}
			return this.formatCurrency(price);
		},

		getSimilarItemSavings(item) {
			if(this.config?.hideSavings) return '';
			const savings = this.extractItemProp(item, 'savingsFr') || this.extractItemProp(item, 'savingsEn');
			const savingsPrefix = this.extractItemProp(item, 'savingsPrefixFr') || this.extractItemProp(item, 'savingsPrefix');
			const savingsSuffix = this.extractItemProp(item, 'savingsSuffix');

			if (!savings) return '';
			return `${savingsPrefix || ''}${savings}${savingsSuffix || ''}`.trim();
		},

		getSimilarItemValidity(item) {
			const validFrom = this.extractItemProp(item, 'validFrom') || this.currentFlyer.startDate;
			const validTo = this.extractItemProp(item, 'validTo') || this.currentFlyer.endDate;
			const start = moment.utc(validFrom);
			const endDate = moment.utc(validTo);

			return `${start.format("D MMM YYYY")} - ${endDate.format("D MMM YYYY")}`;
		},

		handleSimilarItemClick(item) {
			Lytics.TriggerSelectItem({
				item_list_name: "similar product",
				pdp_type: "uniprix pdp",
				name: item.name || this.extractItemProp(item, "productEn") || this.extractItemProp(item, "productFr"),
				name_fr: this.extractItemProp(item, "productFr"),
				name_en: this.extractItemProp(item, "productEn"),
				product_id: item.sku,
				price: this.extractItemProp(item, "regularPrice"),
				sale_price: this.getSimilarItemPrice(item),
				category: this.extractItemProp(item, "mainCategoryEn") || this.extractItemProp(item, "mainCategoryFr"),
				category_2: this.extractItemProp(item, "subCategoryEn") || this.extractItemProp(item, "subCategoryFr"),
				image_url: item.image,
			});

			// Update the PDP with the similar item product
			// Use the event system with the correct data structure
			// This ensures the PDP updates without closing
			const productToOpen = {
				...item,
				blockData: this.product.blockData
			};

			// Trigger the event with both product and blockData
			this.triggerEvent({
				event: PDP_EVENT_SHOW,
				data: {
					product: productToOpen,
					blockData: this.product.blockData
				}
			});
		},

		handleSimilarItemAddToList(item) {
			if (item.isInList) {
				this.handleRemoveFromList(item);
			} else {
				this.handleAddToList(item);
			}
		},

		prevSlide() {
			if (this.carouselIndex > 0) {
				this.carouselIndex--;
			}
		},

		nextSlide() {
			if (this.carouselIndex < this.totalPages - 1) {
				this.carouselIndex++;
			}
		}
	},

	watch: {
		showPdp(val) {
			if (val) {
				setTimeout(() => {
					this.ready = true;
					const pdpFocus = this.$refs.pdpPopup;
					pdpFocus.focus();
				}, 100);
			}
			this.ready = false;
		},
		similarItems() {
			this.carouselIndex = 0;
		}
	},
};
</script>

<style lang="scss" scoped>
.pdp-v4 {
	// background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
	max-width: 600px;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	.pdp-header {
		background-color: var(--secondary-color);
		color: var(--primary-text-color);
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 5px 20px;
		border-radius: 8px 8px 0 0;

		.pdpTitle {
			color: #fff;
			font-size: 18px;
			font-weight: bold;
			text-transform: uppercase;
		}

		.close-btn {
			cursor: pointer;
			background: transparent;
			border: none;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover {
				opacity: 0.8;
			}

			img {
				width: 20px;
				height: 20px;
			}
		}
	}

	.pdp-content {
		background-color: #fff;
		overflow-y: auto;
		flex: 1;

		.content-container {
			text-align: left;
		}
	}
}

.pdpContainer {
	max-width: 100%;

	.top-section {
		padding: 20px;
		display: grid;
		gap: 18px;
		grid-template-columns: 1fr 1fr;
		justify-content: space-between;
		align-items: stretch;
	}

	.details-container {
		display: flex;
		flex-direction: column;
	}

	h2 {
		font-size: 18px;
		line-height: 1.1em;
		display: inline;
	}

    .language {
		text-wrap: balance;
	}

	.productImage {
		padding: 10px;
		max-height: 208px;
		display: block;
		border: 1px solid #ddd;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.price {
		display: flex;
		color: #ee3124;
		font-weight: 900;
		margin-top: 10px;
	}

	span.alternatePrice {
		display: inline-block;
	}

	.alternatePrice {
		color: #000;
		font-size: 14px;
    	font-weight: normal;
    	margin-top: 1px;
	}

	span.tax {
		margin-left: 5px;
	}

	.savings {
		color: #ee3124;
		font-size: 16px;
		margin-top: 5px;
	}

	.regularPrice{
		font-size: 13px;
		font-weight: 900;
		margin-top: 5px;

		.label {
			margin-right: 5px;
		}
	}

	.detail {
		font-size: 15px;
		margin-top: 15px;
		font-weight: 900;

		.detail-content {
			font-size: 12px;
			font-weight: normal;
			margin-top: 5px;
		}
	}

	.disclaimer-content {
		font-size: 12px;
		grid-column: 1 / 3;
	}

	.otp-disclaimer {
		grid-column: 1 / 3;

		.otp-desktop {
			display: block;
			width: 100%;
		}

		.otp-mobile {
			display: none;
		}
	}

	.validity {
		font-size: 13px;
		margin-top: 15px;
	}

	.similar-items {
		background-color: #f9f9f9;
		padding: 0 20px 20px 20px;
		padding-top: 20px;
		border-top: 1px solid #e0e0e0;

		.similar-items-header {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 12px;
		}

		.similar-items-title {
			font-size: 16px;
			font-weight: bold;
			margin: 0;
		}

		.carousel-arrow {
			background-size: contain;
			background-position: center;
			background-repeat: no-repeat;
			width: 25px;
			height: 25px;
			border-radius: 50%;
			opacity: 1;
			transition: opacity 200ms, filter 100ms;
			filter: drop-shadow(0px 0px 0px #222);
			cursor: pointer;
			opacity: 0.5;
		}

		.carousel-arrow:hover:not(.disabled) {
			opacity: 0.7;
			filter: drop-shadow(2px 1px 2px #222);
		}

		.carousel-arrow:active:not(.disabled) {
			filter: drop-shadow(0px 0px 0px #222);
		}

		.carousel-arrow.disabled {
			opacity: 0.2;
			cursor: default;
		}

		.carousel-arrow-prev {
			background-image: url("/images/moveleft-arrow-desktop.png");
			margin-right: auto;
		}

		.carousel-arrow-next {
			background-image: url("/images/moveright-arrow-desktop.png");
			margin-left: auto;
		}

		.similar-items-list {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 15px;

			&.single-item {
				grid-template-columns: 1fr;
			}

			.similar-item {
				border-radius: 8px;
				padding: 15px;
				cursor: pointer;
				display: grid;
				grid-template-columns: 1fr;

				&:hover {
					background-color: #f0f0f0;
				}

				.similar-item-image-container {
					width: 100%;
					height: 150px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 12px;
					background-color: #fff;
					border: 1px solid #e0e0e0;
					border-radius: 4px;
					padding: 10px;

					.similar-item-image {
						max-width: 100%;
						max-height: 100%;
						object-fit: contain;
					}
				}

				.similar-item-details {
					display: flex;
					flex-direction: column;
					gap: 8px;
					flex: 1;

					.similar-item-price {
						font-size: 16px;
						font-weight: 900;
						color: #ee3124;
						line-height: 1.2;
					}

					.similar-item-savings {
						font-size: 14px;
						color: #ee3124;
						font-weight: 600;
					}

					.similar-item-validity {
						font-size: 12px;
						color: #666;
						margin-top: auto;
					}

				}
				.similar-item-add-btn {
					margin-top: 12px;
					padding: 10px;
					background-color: #f5f5f5;
					color: #333;
					border: 1px solid #ddd;
					border-radius: 4px;
					font-size: 12px;
					font-weight: 600;
					cursor: pointer;
					text-transform: uppercase;
					transition: background-color 0.2s, color 0.2s;
					width: 100%;

					&:hover {
						background-color: #e8e8e8;
					}

					&.in-list {
						background-color: #EE3124;
						color: #fff;
						border-color: #EE3124;

						&:hover {
							background-color: #d6281a;
						}
					}
				}
			}
		}
	}
}

.addtoList-container {
	margin-top: auto;
}

.pdpAddToList {
	display: flex;
	cursor: pointer;
	width: 100%;
	border-radius: 5px;
	background-color: var(--secondary-color);
	color: #fff;
	padding: 12px;
	justify-content: center;
	font-weight: normal;
	border: none;
	font-size: 14px;
	text-transform: uppercase;
	margin-top: 14px;

	&:hover {
		opacity: 0.9;
	}

	&.removeFromList {
		background-color: #EE3124;
	}
}

/* Scrollbar styling */
::-webkit-scrollbar {
	width: 10px;
}

::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
	background: #555;
}

/* Mobile responsive */
@media only screen and (max-width: 700px) {
	.pdp-v4 {
		max-width: 500px;

		.pdp-header {
			padding: 12px 15px;

			.pdpTitle {
				font-size: 16px;
			}
		}

		.pdp-content {
			padding: 15px;
		}
	}

	.pdpContainer {
		.top-section {
			grid-template-columns: 1fr;
		}

		.productImage {
			max-height: 200px;
		}

		.details-container {
			grid-column: 1 / 2;

			.pdpAddToList {
				margin-top: 15px;
			}
		}

		.otp-disclaimer {
			.otp-desktop {
				display: none;
			}

			.otp-mobile {
				display: block;
				width: 100%;
			}
		}

		.similar-items {
			.similar-items-header {
				.carousel-arrow {
					display: none;
				}
			}

			.similar-items-list {
				grid-template-columns: 1fr;

				.similar-item {
					grid-template-columns: 1fr 1fr;
					gap: 15px;

					.similar-item-image-container {
						margin-bottom: 0;
					}

					.similar-item-add-btn {
						grid-column: 1 / 3;
					}
				}
			}
		}
	}

}

/* Tablet responsive */
@media only screen and (min-width: 701px) and (max-width: 1024px) {
	.pdp-v4 {
		max-width: 550px;
	}
}
</style>
